import { useEffect, useState } from 'react';
import axios from 'axios';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const dayLabel = (d) => new Date(`${d}T12:00:00`).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short' });

const Stat = ({ label, value, cls, testId }) => (
  <div className="rounded-lg border px-4 py-3" data-testid={testId}>
    <p className="text-xs text-slate-500">{label}</p>
    <p className={`text-2xl font-bold ${cls}`}>{value}</p>
  </div>
);

export const EmailSummaryChart = ({ refreshKey }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/settings/email-logs-summary`).then(res => setData(res.data)).catch(() => setData(null));
  }, [refreshKey]);
  if (!data) return null;
  const chart = data.days.map(d => ({ ...d, label: dayLabel(d.date) }));

  return (
    <div className="grid gap-4 lg:grid-cols-[200px_1fr]" data-testid="email-summary">
      <div className="grid grid-cols-3 lg:grid-cols-1 gap-2">
        <Stat label="Gönderilen (7 gün)" value={data.sent} cls="text-emerald-600" testId="email-summary-sent" />
        <Stat label="Başarısız (7 gün)" value={data.failed} cls="text-rose-600" testId="email-summary-failed" />
        <Stat label="Başarı oranı" value={data.success_rate === null ? '-' : `%${data.success_rate}`} cls="text-slate-800" testId="email-summary-rate" />
      </div>
      <div className="h-56 rounded-lg border p-2" data-testid="email-summary-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chart} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#64748b' }} axisLine={false} tickLine={false} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#64748b' }} axisLine={false} tickLine={false} />
            <Tooltip cursor={{ fill: '#f1f5f9' }} formatter={(v, n) => [v, n === 'sent' ? 'Gönderildi' : 'Başarısız']} />
            <Bar dataKey="sent" stackId="a" fill="#10b981" radius={[0, 0, 0, 0]} />
            <Bar dataKey="failed" stackId="a" fill="#f43f5e" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
